<template>
  <template v-if="!subtextEdit">
    <div class="flex flex-row w-full items-center">
      <p
        :class="[
          type === 'section_label'
            ? 'text-base font-semibold'
            : type === 'field_label'
            ? 'text-base'
            : 'text-xs text-brand-mid-gray italic'
        ]"
      >
        {{ helpText || "Type to enter subtext" }}
      </p>
      <PencilIcon
        class="text-brand-dark-gray w-5 h-5 ml-2"
        :class="[disabled ? 'opacity-50 pointer-event-none' : 'cursor-pointer']"
        @click="toggleSubtextEdit"
      />
    </div>
  </template>
  <template v-else>
    <form class="w-full" @submit.prevent="toggleSubtextEdit">
      <div class="flex w-full flex-row items-center">
        <input
          class="
            w-1/2
            text-brand-dark-gray
            py-1
            px-2
            border border-brand-mid-gray
            shadow-sm
            rounded
            placeholder-brand-mid-gray
            focus:outline-none
            focus:ring-1
            focus:border-brand-green
            focus:ring-brand-green
            mr-2
          "
          :class="[type === 'field_subtext' ? 'text-xs' : 'text-base']"
          :value="helpText"
          @change="updateText"
        />
        <p class="text-brand-green cursor-pointer" @click="toggleSubtextEdit">
          done
        </p>
      </div>
    </form>
  </template>
</template>
<script>
import { PencilIcon } from "@heroicons/vue/solid"
export default {
  props: {
    helpText: {
      type: String
    },
    type: {
      type: String,
      default: "field_subtext" //section_label, field_label
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    PencilIcon
  },
  data() {
    return {
      subtextEdit: false
    }
  },
  methods: {
    updateText(ev) {
      this.$emit("update", ev.target.value)
    },
    toggleSubtextEdit() {
      if (this.disabled) {
        return
      }
      this.subtextEdit = !this.subtextEdit
    }
  }
}
</script>
